import { LANGUAGES } from '@/constants/constants';
import _ from 'lodash';
export function makeLanguages(activeLanguage) {
    return _.map(LANGUAGES, lang => {
        const active = activeLanguage === lang.key;
        return {
            ...lang,
            active,
        };
    });
}
